<div class="container">
  <header class="header">
    <div class="icon-wrapper">
      @if (iconUrl) {
        <img [src]="iconUrl" alt="アイコン" class="icon" />
      }
    </div>
    <div class="title">Biz-Marche</div>
  </header>

  <main class="content">
    <!-- 新しい動画ができるまでの暫定表示。動画を復活させるときはこの画像を消し、下のコメントを外して
         TopComponent の videoUrls に新しい動画を入れる（footer の dot-indicators も同様にコメントを外す）。 -->
    <div class="eye-catch-image-container">
      <img class="eye-catch-image" src="assets/img/world_visual.jpg" alt="Biz-Marche" />
    </div>
    <!--
    <div class="video-container" [class.initial-ready]="isInitialVideoReady">
      <video
        #videoPlayer
        [src]="currentVideoUrl"
        [muted]="true"
        autoplay
        playsinline
        preload="auto"
        (ended)="onVideoEnded()"
        (loadeddata)="onVideoLoaded()"
        class="eye-catch-video"
        [class.is-switching]="isVideoSwitching"
      ></video>
    </div>
    -->
  </main>

  <footer class="footer">
    <!-- 動画の切り替えドット。動画を復活させるときにコメントを外す。
    <div class="dot-indicators">
      @for (video of videoUrls; track $index) {
        <button
          type="button"
          class="indicator-dot"
          [class.active]="$index === currentStep"
          (click)="goToVideo($index)"
          [attr.aria-label]="'動画 ' + ($index + 1) + ' を表示'"
        ></button>
      }
    </div>
    -->
  </footer>

  <div class="fab-group">
    <button class="fab register" (click)="clickRegister()">Register</button>
    <button class="fab login" (click)="clickLogin()">Login</button>
  </div>
</div>
